<template>
  <div class="container-center-horizontal">
    <div class="pearl-report-375 screen">
      <div class="overlap-group-1" :style="{ 'background-image': 'url(' + overlapGroup + ')' }">
        <div class="rectangle-11-1"></div>
        <h1 class="name-2">{{ title }}</h1>
        <img class="logo-01-1" src="img/logo-01-23.svg" alt="logo-01" />
        <img class="union" src="img/union-26.svg" alt="Union" @click="drawer = true" />
      </div>
      <p class="pearls-submitted-to-1 heebo-normal-mine-shaft-12px" v-html="pearlsSubmittedTo"></p>
      <div class="group-20-2">
        <img class="group-20-item-2" :src="x1" alt="1" />
        <!-- <img class="group-20-item-2" :src="x3" alt="3" /> -->
      </div>
      <div class="testing-methods-1 heebo-bold-black-16px">{{ testingMethods }}</div>
      <p class="all-pearls-submitted-1 heebo-normal-mine-shaft-12px">{{ allPearlsSubmitted }}</p>
      <div class="name-3 heebo-bold-black-16px">{{ name2 }}</div>
      <p class="includes-the-followi-1 heebo-normal-mine-shaft-12px" v-html="includesTheFollowi"></p>
      <img class="rectangle-105-1" :src="rectangle105" alt="Rectangle 105" />
      <foot-bottom v-bind="globalData" />
      <el-drawer direction="ltr" :visible.sync="drawer" :with-header="false" size="50%">
        <left-nav />
      </el-drawer>
    </div>
  </div>
</template>

<script>
import LeftNav from "../components/Navbar";
import FootBottom from "../components/FootBottom";
export default {
  name: "PearlReport375",
  components: {
    LeftNav,
    FootBottom,
  },
  data() {
    return {
      drawer: false,
    }
  },
  props: [
    "globalData",
    "overlapGroup",
    "title",
    "pearlsSubmittedTo",
    "x1",
    "x3",
    "testingMethods",
    "allPearlsSubmitted",
    "name2",
    "includesTheFollowi",
    "rectangle105",
  ],
};
</script>

<style lang="sass" scoped>
@import '../../../variables'

.pearl-report-375
  align-items: center
  background-color: $selago
  display: flex
  flex-direction: column
  height: 1603px
  width: 375px

.overlap-group-1
  background-position: 50% 50%
  background-size: cover
  height: 200px
  position: relative
  width: 375px

.rectangle-11-1
  background-color: $black-2
  height: 200px
  left: 0
  position: absolute
  top: 0
  width: 375px

.name-2
  color: $white
  font-family: $font-family-plus_jakarta_sans
  font-size: $font-size-xxl
  font-weight: 700
  left: 100px
  letter-spacing: 0
  line-height: normal
  position: absolute
  top: 89px

.logo-01-1
  height: 26px
  left: 143px
  position: absolute
  top: 10px
  width: 90px

.union
  height: 17px
  left: 15px
  position: absolute
  top: 15px
  width: 19px

.pearls-submitted-to-1
  letter-spacing: 0
  line-height: 18px
  margin-top: 19px
  min-height: 196px
  width: 335px

.group-20-2
  align-items: flex-start
  display: flex
  margin-right: 10.0px
  margin-top: 21px
  min-width: 335px

.group-20-item-2
  height: 236px
  object-fit: cover
  width: 336px

.testing-methods-1
  align-self: flex-start
  letter-spacing: 0
  line-height: 19.2px
  margin-left: 20px
  margin-top: 29px
  white-space: nowrap

.all-pearls-submitted-1
  letter-spacing: 0
  line-height: 18px
  margin-top: 10px
  min-height: 120px
  width: 335px

.name-3
  align-self: flex-start
  letter-spacing: 0
  line-height: 19.2px
  margin-left: 20px
  margin-top: 30px
  white-space: nowrap

.includes-the-followi-1
  letter-spacing: 0
  line-height: 18px
  margin-right: 5.0px
  margin-top: 10px
  min-height: 198px
  width: 330px

.rectangle-105-1
  align-self: flex-start
  height: 200px
  margin-left: 20px
  margin-top: 11px
  object-fit: cover
  width: 260px

.group-16
  align-items: flex-start
  display: flex
  gap: 16px
  height: 185px
  margin-right: 41.0px
  margin-top: 40px
  min-width: 274px

.logo-02-1
  height: 42px
  width: 34px

.flex-col-2
  align-items: flex-start
  display: flex
  flex-direction: column
  margin-top: 0
  min-height: 185px
  width: 214px

.about-algt-1
  letter-spacing: 0
  line-height: normal
  margin-left: 15px
  min-height: 20px

.flex-col-item
  letter-spacing: 0
  line-height: normal
  margin-left: 15px
  margin-top: 20px
  min-height: 20px

.x2023-algt-all-rights-reserved-1
  letter-spacing: 0
  line-height: normal
  margin-top: 30px
  min-height: 15px

</style>
